<template>
  <span>
    <a v-if="modules && !!modules['meter_data']" href="#" @click.prevent="openMeters()"><fa-icon icon="chart-area" />Utility Meters</a>
    <b-modal ref="utilityMetersmodal" size="lg" no-enforce-focus title="Product utility meters">
      <b-row>
        <b-col cols="8">
          <b-button-toolbar class="float-right" key-nav>
            <b-button-group>
              <b-button variant="success" @click="newUtilityMeterItem">
                <fa-icon icon="plus" /> New
              </b-button>
            </b-button-group>
          </b-button-toolbar>

          <b-table
            empty-html="No items to show" :fields="utiliityMeterFields" :items="utilityMeters" small responsive striped
            hover show-empty
          >
            <template v-slot:cell(utilityMeterTypeId)="{ item }">
              {{ item.utilityMeterType.name }} ({{ item.utilityMeterType.unit }})
            </template>
            <template v-slot:cell(taxId)="{ item }">
              {{ item.tax.name }} ({{ item.tax.percentage }}%)
            </template>
            <template v-slot:cell(actions)="{ item }">
              <a href="#" class="text-primary" title="Edit" @click.prevent="editUtilityMeterItem(item)"><fa-icon icon="edit" /></a>
              <a href="#" class="text-danger" title="Delete" @click.prevent="removeUtilityMeterItem(item)"><fa-icon icon="trash" /></a>
            </template>
          </b-table>
        </b-col>
        <b-col v-if="newEditMeter">
          <form @submit.prevent="saveService">
            <b-form-group label="Utility Meter Type">
              <blueprint-search-input
                :key="utilityMeter.utilityMeterTypeId"
                v-model="utilityMeter.utilityMeterTypeId"
                placeholder="Type to search"
                api-route-path="inventory/utilitymetertypes"
              />
            </b-form-group>
            <b-form-group label="Price" label-for="price" description="Without taxes">
              <b-form-input id="price" v-model="utilityMeter.price" step="0.01" type="number" placeholder="Price" />
            </b-form-group>
            <b-form-group label="Tax" label-for="taxId">
              <blueprint-search-input
                id="taxId"
                v-model="utilityMeter.taxId"
                placeholder="Type to search"
                api-route-path="inventory/taxes"
                :state="state('taxId')"
              />
            </b-form-group>
            <b-form-group v-if="modules && !!modules['invoices']" label="Product code">
              <b-form-input id="productCode" v-model="utilityMeter.productCode" :state="state('productCode')" type="text" placeholder="Product Code" />
            </b-form-group>
            <div class="text-center">
              <b-button variant="success" type="submit">Save</b-button>
            </div>
          </form>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="dark" @click="cancel()">Close</b-button>
      </template>
    </b-modal>
  </span>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartArea } from '@fortawesome/free-solid-svg-icons';

library.add(faChartArea);

export default {
  props: ['productId'],
  data () {
    return {
      errors: [],
      utilityMeter: {},
      newEditMeter: false,
      utilityMeters: [],
      utiliityMeterFields: [
        {
          key: 'utilityMeterTypeId',
          label: 'Meter Type',
        },
        {
          key: 'price',
        },
        {
          key: 'taxId',
          label: 'Tax',
        },
        {
          key: 'actions',
          class: 'actions',
        },
      ],
    };
  },
  computed: {
    modules () {
      return this.$store.getters.modules;
    },
  },
  methods: {
    error (title, msg) {
      this.$notify({
        title,
        text: msg,
        type: 'error',
      });
    },
    err (err) {
      this.error('Error', err.response && err.response.data ? err.response.data.message || err.message : err.message);
      this.errors = err.response && err.response.data ? err.response.data.details || {} : {};
      throw err;
    },
    state (item) {
      return (this.errors[item] ? false : null);
    },
    openMeters () {
      this.newEditMeter = false;
      this.getUtilityMeters()
        .then(() => this.$refs.utilityMetersmodal.show())
        .catch(this.err);
    },

    getUtilityMeters () {
      return this.$http.get(`inventory/products/${this.productId}/utilitymeters`)
        .then((res) => {
          this.utilityMeters = res.data;
          this.errors = {};
        })
        .catch(this.err);
    },
    saveService () {
      const { utilityMeter } = this;
      const url = `inventory/products/${this.productId}/utilitymeters`;
      let promise;
      if (utilityMeter.id) {
        promise = this.$http.patch(`${url}/${utilityMeter.id}`, utilityMeter);
      } else {
        promise = this.$http.post(url, utilityMeter);
      }
      promise
        .then(() => {
          this.utilityMeter = {};
          this.newEditMeter = false;
        })
        .then(() => this.getUtilityMeters())
        .catch(this.err);
    },
    newUtilityMeterItem () {
      this.utilityMeter = { utilityMeter: { }, price: '0' };
      this.newEditMeter = true;
    },
    editUtilityMeterItem (item) {
      const { id } = item;
      const url = `inventory/products/${this.productId}/utilitymeters/${id}`;
      this.$http.get(url)
        .then((res) => {
          this.utilityMeter = res.data;
          this.newEditMeter = true;
        })
        .catch(this.err);
    },
    removeUtilityMeterItem (item) {
      const { id } = item;
      const url = `inventory/products/${this.productId}/utilitymeters/${id}`;
      this.$http.delete(url)
        .then(() => this.getUtilityMeters())
        .catch(this.err);
    },
  },
};
</script>
